export default __webpack_public_path__ + "static/media/register-account-bee.ddba4dc5.svg";